var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, watch } from "vue";
import { fetchDatasetStorage } from "@/api/datasets";
import { errorMessageAsString } from "@/utils/simple-error";
import RelocateLink from "./RelocateLink.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
import DescribeObjectStore from "@/components/ObjectStore/DescribeObjectStore.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'DatasetStorage',
    props: {
        datasetId: null,
        datasetType: { default: "hda" },
        includeTitle: { type: Boolean, default: true }
    },
    setup(__props) {
        const props = __props;
        const storageInfo = ref(null);
        const errorMessage = ref(null);
        const discarded = computed(() => {
            var _a;
            return ((_a = storageInfo.value) === null || _a === void 0 ? void 0 : _a.dataset_state) == "discarded";
        });
        const deferred = computed(() => {
            var _a;
            return ((_a = storageInfo.value) === null || _a === void 0 ? void 0 : _a.dataset_state) == "deferred";
        });
        const sourceUri = computed(() => {
            var _a, _b;
            const sources = (_a = storageInfo.value) === null || _a === void 0 ? void 0 : _a.sources;
            if (!sources) {
                return null;
            }
            const rootSources = sources.filter((source) => !source.extra_files_path);
            if (rootSources.length == 0) {
                return null;
            }
            return (_b = rootSources[0]) === null || _b === void 0 ? void 0 : _b.source_uri;
        });
        function fetch() {
            return __awaiter(this, void 0, void 0, function* () {
                const datasetId = props.datasetId;
                const datasetType = props.datasetType;
                try {
                    const response = yield fetchDatasetStorage({ dataset_id: datasetId, hda_ldda: datasetType });
                    storageInfo.value = response.data;
                }
                catch (error) {
                    errorMessage.value = errorMessageAsString(error);
                }
            });
        }
        watch(props, fetch, { immediate: true });
        return { __sfc: true, props, storageInfo, errorMessage, discarded, deferred, sourceUri, fetch, RelocateLink, LoadingSpan, DescribeObjectStore };
    }
});
